<section class="main-section form-section">
<form>
    <div class="row mt-3">
    <div class="col">
    <div class="inner-box">
        <h2 class="text-black">Assign Driver</h2>
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group select-form-group">
              <label class="control-label" for="driverName">Driver Name</label>
              <select id="driverName" class="form-control" (blur)="selectDriverName()" [ngClass]="{'is-invalid':statusText1}" [(ngModel)]="driverName" [ngModelOptions]="{standalone: true}" required>
                <option *ngFor="let d of driversList" [ngValue]="d.id">{{d.driverName}}</option>
              </select>
              <div id="errorMessage"class="invalid-feedback d-block" [hidden]="!errorMessage">{{errorMessage}}</div>
              <div id="statusText1" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText1">{{statusText1}}</div>
            </div>
          <div class="form-group required">
          <h2 class="text-black mb-3">Comments</h2>
          <textarea  id="description" [(ngModel)]="comments" class="form-control" (blur)="typeComments()" [ngClass]="{'is-invalid':statusText2}" rows="6"  [ngModelOptions]="{standalone: true}"  required></textarea>
            <div id="statusText2" class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText2">{{statusText2}}</div>
          </div>
        </div>
        </div>
    </div>
    </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
    <button type="submit" class="btn btn-cancel" routerLink="/admin/adminShipmentList">cancel</button>
    <button type="submit" class="btn btn-orange ml-2" (click)="submitAssignment()">Submit</button>
  </div>
</div>
</div>
